<template >
  <div class="container">
      
    <div class="card">
        <div class="card-header">
            <h4 class="text-primary font-weight-bold">Эцсийн дүн</h4>
        </div>
        <div class="card-body">
            <table class="table table-borderd">
                <thead class="text-right text-primary font-weight-bold">
                    <td width="1"></td>
                    <td>Даалгавар</td>
                    <td>Аваx оноо</td>
                    <td>Авсан оноо</td>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in results" class="text-right">
                        <td v-if="item.category==false">{{index+1}}.</td>
                        <td class="question-title" v-if="item.category==true">{{item.name}}</td>
                        <td class="question-title" v-if="item.category==false">{{item.name}}</td>
                        <td v-if="item.category==false">{{item.score}}</td>
                        <td v-if="item.category==false" class="font-weight-bold text-danger">{{item.finalscore}}</td>
                    </tr>
                    <tr class="text-right">
                        <td></td>
                        <td>&nbsp;</td>
                        <td class="font-weight-bold">{{totalScore}}</td>
                        <td class="font-weight-bold text-danger">{{finalScore}}</td>
                    </tr>
                </tbody>
            </table>
            <!-- <p class="float-right">Total</p> -->
        </div>
    </div>
  </div>
</template>

<script>
const fb = require("../../firebaseConfig.js");
import firebase from 'firebase'
import { mapState } from "vuex";
import myfunction from '../global/myfunction.js';
export default {
  name: "ExamReport",
  computed: {
    ...mapState(["currentUser", "enabled", "userProfile"])
  },
  mixins:[myfunction],
  data() {
    return {
      testFinished: false,
      showCorrectAnswer: false,
      performingRequest: false,
      results:[],
      totalScore:0,
      finalScore:0
    };
  },
  watch: {
 
  },
  created() {
      this._travesalQA();
  },
  props: {
      categories:{
        required: true,
        type: Object
      },
  },
  methods: {
  
    _travesalQA(){
      for(var category of this.categories){
        this.results.push({category:true, name:category.name, count:0});
        for(var question of category.questions){
          //console.log(question);
          for(var subquestion of question.subquestions){
            console.log(subquestion.title, subquestion.useranswer.correct, subquestion.score);
            var finalScore;
            if(subquestion.useranswer.correct==true)
                finalScore = subquestion.score;
            else
                finalScore = 0;
            this.finalScore = this.finalScore + finalScore;
            this.totalScore = this.totalScore + subquestion.score
            this.results.push({category:false, name:subquestion.title, score: subquestion.score, finalscore: finalScore});
            for(var answer of subquestion.answers){
              //console.log(answer);
            }
          }
        }
      }
    },
  }
};
</script>
<style>
  #iframecontainer iframe{
    width:100%!important;
  }
  .answered{
    background:rgb(207, 207, 207);
    color:black 
  }
  .question-title{
      color:black
  }
</style>
